var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch } from "react-redux";
import { MoreOptionIcon } from "../../../assets/customIcons";
import { ChevronDown, ChevronUp } from "../../../assets/images";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { getListAPI, setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { CallIconSVG } from "../assets/assets";
import { JobCardInvoicesKeys, ValidateJCInvoiceURL } from "../../jobcardInvoices/services/entity";
import { showNotification } from "../../../redux/commonSlice";
import { useNavigate } from "react-router-dom";
var CardView = function (_ref) {
    var _crud$pagingKey$data, _crud$pagingKey;
    var onActionResponse = _ref.onActionResponse, apiCallFunction = _ref.pagingApiCall, apiRequest = _ref.pagingRequest, pagingKey = _ref.pagingKey, _a = _ref.pageSize, pageSize = _a === void 0 ? 20 : _a, cardMapper = _ref.cardMapper, _b = _ref.actions, actions = _b === void 0 ? React.createElement(MoreOptionIcon, {
        sx: {
            color: systemColor.darkGrey
        }
    }) : _b, callIconVisibleFor = _ref.callIconVisibleFor, actionsMenu = _ref.actionsMenu, menuIcons = _ref.menuIcons, onCardClick = _ref.onCardClick, _c = _ref.isReadyForInvoiceTitle, isReadyForInvoiceTitle = _c === void 0 ? false : _c, _d = _ref.isGrandTotalButton, isGrandTotalButton = _d === void 0 ? false : _d, _e = _ref.isCreateReturn, isCreateReturn = _e === void 0 ? false : _e, _f = _ref.isMenuIcon, isMenuIcon = _f === void 0 ? false : _f, _g = _ref.isExpandButton, isExpandButton = _g === void 0 ? false : _g;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _h = useState((_crud$pagingKey$data = crud === null || crud === void 0 || (_crud$pagingKey = crud[pagingKey]) === null || _crud$pagingKey === void 0 ? void 0 : _crud$pagingKey.data) !== null && _crud$pagingKey$data !== void 0 ? _crud$pagingKey$data : []), dataList = _h[0], setDataList = _h[1];
    var _j = useState(true), hasMore = _j[0], setHasMore = _j[1];
    var _k = useState({}), expanded = _k[0], setExpanded = _k[1];
    var _l = useState(new Set()), uniqueIds = _l[0], setUniqueIds = _l[1];
    var pagingUpdateKey = pagingKey + 'Updated';
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var appDispatch = useAppDispatch();
    var loadMoreData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$data, response, newData, uniqueData_1, updatedIds, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiCallFunction({
                            request: _objectSpread({}, apiRequest)
                        })];
                case 1:
                    response = _a.sent();
                    newData = (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : [];
                    uniqueData_1 = newData.filter(function (item) { return !(uniqueIds !== null && uniqueIds !== void 0 && uniqueIds.has(item === null || item === void 0 ? void 0 : item.id)); });
                    updatedIds = new Set(__spreadArray(__spreadArray([], uniqueIds, true), (uniqueData_1 === null || uniqueData_1 === void 0 ? void 0 : uniqueData_1.map(function (item) { return item === null || item === void 0 ? void 0 : item.id; })), true));
                    setUniqueIds(updatedIds);
                    setDataList(function (prevDataList) { return __spreadArray(__spreadArray([], prevDataList, true), uniqueData_1, true); });
                    if (uniqueData_1.length < pageSize) {
                        setHasMore(false);
                    }
                    dispatch(setReducerState({
                        key: pagingUpdateKey,
                        value: false
                    }));
                    if (pagingUpdateKey) {
                        setDataList(__spreadArray([], newData, true));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error while fetching data:", error_1);
                    setHasMore(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if ((dataList === null || dataList === void 0 ? void 0 : dataList.length) === 0 && hasMore) {
            loadMoreData();
        }
    }, []);
    useEffect(function () {
        if (crud[pagingUpdateKey]) {
            loadMoreData();
        }
    }, [crud[pagingUpdateKey]]);
    // const handleGenerateInvoice = async() => {
    //     const res = await dispatch(getListAPI({ key: JobCardInvoicesKeys.ValidateJCInvoice, url: ValidateJCInvoiceURL, request: { JobCardId: row?.JobCardId } }))
    //     if (res?.payload?.value?.success && res?.payload?.value?.statusCode === 200) {
    //         navigate(`/create-invoice/${row?.JobCardId}`)
    //     }
    //     else {
    //         dispatch(
    //             showNotification({
    //                 isOpen: true,
    //                 message: `${res?.payload?.value?.message}`,
    //                 type: "error",
    //             })
    //         );
    //     }
    // }
    return /*#__PURE__*/ React.createElement(InfiniteScroll, {
        dataLength: dataList === null || dataList === void 0 ? void 0 : dataList.length,
        next: loadMoreData,
        hasMore: hasMore,
        loader: /*#__PURE__*/ React.createElement("h4", null)
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        direction: 'row',
        paddingX: 2
    }, dataList === null || dataList === void 0 ? void 0 : dataList.map(function (item, index) {
        var cardData = cardMapper(item);
        var formData = [{
                type: FormItemTypes.CardComponent,
                name: cardData === null || cardData === void 0 ? void 0 : cardData.id,
                columnSize: 12,
                onClick: function () { },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "".concat(cardData === null || cardData === void 0 ? void 0 : cardData.id, "-header"),
                        columnSize: 12,
                        justifyContent: "space-between",
                        display: "flex",
                        alignItems: 'flex-start',
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: 4,
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                flexDirection: 'column',
                                spacing: 0,
                                elements: [isReadyForInvoiceTitle ? {
                                        type: FormItemTypes.Typography,
                                        name: "DocNo",
                                        columnSize: true,
                                        labelTypographyProps: {
                                            fontSize: 'base',
                                            fontWeight: 'medium'
                                        },
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: systemColor.black
                                    } : null, {
                                        type: FormItemTypes.Typography,
                                        name: "DocNo",
                                        label: cardData.docNo,
                                        children: cardData.title,
                                        columnSize: true,
                                        labelTypographyProps: {
                                            fontSize: 'base',
                                            fontWeight: 'medium',
                                            color: '#1B1D21'
                                        },
                                        fontSize: 'sm',
                                        fontWeight: 'normal',
                                        color: systemColor.lightGrey
                                    }]
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: 4,
                                justifyContent: 'flex-end',
                                alignItems: 'baseline',
                                spacing: 1,
                                elements: [cardData !== null && cardData !== void 0 && cardData.statusName ? {
                                        type: FormItemTypes.Chip,
                                        name: 'StatusName',
                                        value: cardData === null || cardData === void 0 ? void 0 : cardData.statusName,
                                        variant: 'outlined',
                                        size: 'small',
                                        columnSize: 0,
                                        color: 'warning',
                                        sx: {
                                            borderRadius: '6px'
                                        }
                                    } : null, isMenuIcon ? {
                                        type: FormItemTypes.IconButton,
                                        name: "menuIcon",
                                        children: actions,
                                        columnSize: 0,
                                        sx: {
                                            width: '18px',
                                            height: '18px'
                                        },
                                        setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                            var action;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, appDispatch(showSurface({
                                                            type: 'Menu',
                                                            containerProps: {
                                                                anchorEl: e.target.parentElement
                                                            },
                                                            Component: ActionMenuList,
                                                            componentProps: {
                                                                items: __spreadArray([], actionsMenu.map(function (item) {
                                                                    return {
                                                                        id: item === null || item === void 0 ? void 0 : item.Name,
                                                                        children: [menuIcons(item === null || item === void 0 ? void 0 : item.Name), item === null || item === void 0 ? void 0 : item.DisplayName]
                                                                    };
                                                                }), true)
                                                            }
                                                        }))];
                                                    case 1:
                                                        action = _a.sent();
                                                        if (onActionResponse) {
                                                            onActionResponse(item, action);
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); }
                                    } : null]
                            }]
                    }, {
                        type: FormItemTypes.ContainerItem,
                        name: "".concat(cardData.id, "-details"),
                        columnSize: 12,
                        spacing: 0.5,
                        flexDirection: "row",
                        bgcolor: "#F4F7FA",
                        borderRadius: 2,
                        padding: 1,
                        marginY: 1.5,
                        marginLeft: '16px',
                        display: expanded[cardData.id] ? "flex" : "none",
                        elements: cardData.details.map(function (detail) { return ({
                            type: FormItemTypes.Typography,
                            name: detail.label,
                            label: "".concat(detail.label),
                            justifyContent: 'flex-end',
                            sx: {
                                justifyContent: 'flex-start'
                            },
                            children: /*#__PURE__*/ React.createElement("div", {
                                style: {
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'row'
                                }
                            }, detail.label === callIconVisibleFor && detail.value && /*#__PURE__*/ React.createElement(CallIconSVG, null), /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: detail.label === callIconVisibleFor ? 'base' : 'sm',
                                color: detail.label && detail.label === callIconVisibleFor ? systemColor.primary : '#1B1D21',
                                fontWeight: "medium",
                                textAlign: 'right'
                            }, detail.value ? detail.value : '-')),
                            columnSize: 12,
                            containerProps: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }
                        }); })
                    }, {
                        type: FormItemTypes.ContainerItem,
                        name: "".concat(cardData.id, "-footer"),
                        sx: {
                            width: "100%",
                            justifyContent: isExpandButton && isGrandTotalButton || isCreateReturn ? 'space-between' : 'flex-end',
                            alignItems: 'center'
                        },
                        columnSize: 12,
                        elements: [isGrandTotalButton ? {
                                type: FormItemTypes.Button,
                                name: 'GenerateInvoiceBtn',
                                children: 'Generate Invoice',
                                columnSize: 0,
                                variant: 'outlined',
                                color: 'primary',
                                sx: {
                                    padding: '8px 12px 8px 12px'
                                },
                                onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    var _cardData$id, _res$payload, _res$payload2, jobCardId, res, _res$payload3;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                jobCardId = cardData === null || cardData === void 0 || (_cardData$id = cardData.id) === null || _cardData$id === void 0 ? void 0 : _cardData$id.replace('card-', '');
                                                return [4 /*yield*/, dispatch(getListAPI({
                                                        key: JobCardInvoicesKeys.ValidateJCInvoice,
                                                        url: ValidateJCInvoiceURL,
                                                        request: {
                                                            JobCardId: jobCardId
                                                        }
                                                    }))];
                                            case 1:
                                                res = _a.sent();
                                                if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success && (res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.value) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.statusCode) === 200) {
                                                    navigate("/create-invoice/".concat(jobCardId));
                                                }
                                                else {
                                                    dispatch(showNotification({
                                                        isOpen: true,
                                                        message: "".concat(res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.value) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.message),
                                                        type: "error"
                                                    }));
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            } : null, isCreateReturn ? {
                                type: FormItemTypes.Button,
                                name: 'creteReturnBtn',
                                children: 'Create return',
                                columnSize: 0,
                                variant: 'text',
                                sx: {
                                    ml: -1.3
                                },
                                color: 'primary',
                                onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/];
                                    });
                                }); }
                            } : null, {
                                type: FormItemTypes.Button,
                                name: "viewMore",
                                children: expanded[cardData.id] ? isExpandButton ? 'Close' : 'View less' : isExpandButton ? 'Open' : 'View more',
                                sx: {
                                    color: systemColor.darkGrey,
                                    justifyContent: "center",
                                    whiteSpace: "nowrap",
                                    padding: 0
                                },
                                endIcon: expanded[cardData.id] ? isExpandButton ? /*#__PURE__*/ React.createElement("img", {
                                    src: ChevronUp,
                                    alt: "Collapse"
                                }) : /*#__PURE__*/ React.createElement("img", {
                                    src: ChevronDown,
                                    alt: "Expand"
                                }) : isExpandButton ? /*#__PURE__*/ React.createElement("img", {
                                    src: ChevronDown,
                                    alt: "Expand"
                                }) : /*#__PURE__*/ React.createElement("img", {
                                    src: ChevronUp,
                                    alt: "Collapse"
                                }),
                                columnSize: 0,
                                onClick: function () {
                                    setExpanded(function (prev) {
                                        var _a;
                                        return _objectSpread(_objectSpread({}, prev), {}, (_a = {},
                                            _a[cardData.id] = !prev[cardData.id],
                                            _a));
                                    });
                                }
                            }]
                    }]
            }];
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 4
        }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
            key: cardData.id || index,
            formData: formData,
            gridSpacing: 0
        }));
    })));
};
export default CardView;
